<template>
  <b-modal id="address-modal-detail" ref="modal" size="lg" title="Detail" @show="setData" @hidden="resetModal">
    <b-form >
      <div class="row">
        <!-- grid column -->
        <div class="col-lg-12">
          <!-- .card -->
          <div class="card card-fluid">
            <!-- .card-body -->
            <div class="card-body">
              <div class="form-row">
                <label class="col-md-3">Street</label>
                <div class="col-md-8 mb-3">
                  {{detail.street}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Address Type</label>
                <div class="col-md-8 mb-3">
                  {{detail.type_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Country</label>
                <div class="col-md-8 mb-3">
                  {{detail.country_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">State</label>
                <div class="col-md-8 mb-3">
                  {{detail.state_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">City</label>
                <div class="col-md-8 mb-3">
                  {{detail.city_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Sub District</label>
                <div class="col-md-8 mb-3">
                  {{detail.sub_district_name}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Village</label>
                <div class="col-md-8 mb-3">
                  {{detail.village}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Postal Code</label>
                <div class="col-md-8 mb-3">
                  {{detail.postal_code}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Phone Number</label>
                <div class="col-md-8 mb-3">
                  {{detail.phone_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Fax No</label>
                <div class="col-md-8 mb-3">
                  {{detail.fax_number}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Description</label>
                <div class="col-md-8 mb-3">
                  {{detail.desc}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Status</label>
                <div class="col-md-8 mb-3">
                  {{detail.status == 1 ? 'Active':'Non Active'}}
                </div>
              </div>
              <div class="form-row">
                <label class="col-md-3">Last Modified</label>
                <div class="col-md-8 mb-3">
                  {{detail.last_modified}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import {BModal, BForm} from 'bootstrap-vue'
export default {
  name: "AddressDetailForm",
  components:{
    BModal,
    BForm
  },
  props:{
    data:{
      type:Object
    }
  },
  data(){
    return {
      detail:{
        street:"",
        type_name:"",
        state_name:"",
        city_name:"",
        sub_district_name:"",
        village:"",
        postal_code:"",
        phone_number:"",
        fax_number:"",
        desc:"",
        last_modified:""
      }
    }
  },
  methods:{
    setData(){
      setTimeout(()=>{
        if(this.data !== null){
          this.detail = this.data
        }
      })
    },
    resetModal(){
      this.$parent.data = null
      this.detail = {}
      this.$refs.modal.hide()
    }
  }
}
</script>